import { OrganizationEncryptionAccessTimesEndpoint } from '../endpoints/OrganizationEncryptionAccessTimes';
import { authResource } from './Auth';
export const OrganizationEncryptionAccessTimesResource = authResource({
    path: '/organizations/:organizationId/encryptions/accesstimes/:accessTimeId?',
    schema: {},
    Endpoint: OrganizationEncryptionAccessTimesEndpoint
}).extend('partialUpdate', {
    body: {
        encryptionGUIDs: [],
        sunriseDTTM: null,
        sunsetDTTM: null
    },
    schema: undefined
});
